import axios from "axios";
import { KpiSettings } from "../interfaces/settings";

export function getKpiSettings() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/settings/kpis';
    return axios.get(endpointUrl, { headers: headers });
}

export function updateKpiSettings(body_obj: KpiSettings) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/settings/kpis';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function getAppVersion() {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/badminton/ws/v1/version';
    return axios.get(endpointUrl, { headers: headers });
}
